<style lang="stylus">
    .importModal-mask
        modal-mask()
        z-index 120
        .importModal-box
            width 480px
            max-width 100%
            position fixed
            top 50%
            left 50%
            transform translate(-50%, -50%)
            background-color #fff
            box-shadow 0 2px 12px 0 rgba(0, 0, 0, 0.2)
            border-radius $box-radius
            .importModal-header
                height 40px
                padding 0 12px
                display flex
                font-size 12px
                color #222222
                align-items center
                user-select none
                >span
                    margin-left 4px
                .header-close
                    position absolute
                    display flex
                    align-items center
                    justify-content center
                    width 24px
                    height 24px
                    top 8px
                    right 8px
                    cursor pointer
                    border-radius 6px
                    &:hover
                        background rgba(0,0,0,0.06)

                    svg
                        width 10px
                        height 10px
            .importModal-content
                padding 16px 24px
                .content-loading
                    height 300px
                    border 1.5px dashed #c6c6c6
                    display flex
                    justify-content center
                    align-items center
                    z-index 10
                    img
                        width 200px
                .content-box
                    position relative
                    display block
                    height 322px
                    border 1.5px dashed rgba(0, 0, 0, 0.1);
                    cursor pointer
                    background-color: #f5faff
                    border-radius: $box-radius;
                    &.no-drag
                        .content-text
                            display none
                    .vip-tag
                        position absolute
                        left -2px
                        top -2px
                        border-radius $box-radius 0
                        padding 0 8px
                        line-height 20px
                        &.limit-free
                            color #fff
                            background linear-gradient(254.74deg, #ff4b3a -1.34%, #ff974d 103.79%)
                        &.vip
                            color #4a320e
                            background: linear-gradient(95.41deg, #ffef99 0%, #ffd270 100%)
                    &:not(.no-drag):hover,&:not(.no-drag).active{
                      border-color: var(--themeColor);
                      background-color: #f0f7ff;
                      color: var(--themeColor);
                    }
                    &:hover .content-text{
                      color: var(--themeColor);
                    }
                .content-img
                    display flex
                    align-items flex-end
                    justify-content center
                    margin-top 64px
                    margin-bottom 4px
                    svg
                        width 96px
                        height 96px
                .content-text
                    text-align center
                    font-size 16px
                    color rgba(34, 34, 34, 0.4);
                .content-btnbox
                    padding-top 24px
                    text-align center
                    .content-btn
                        display inline-block
                        position relative
                        height 36px
                        padding 5px 30px
                        margin 0 auto
                        background-color var(--themeColor);
                        font-size 16px
                        text-align center
                        line-height 26px
                        color #fff
                        cursor pointer
                        border-radius 4px
                        transition background-color .2s
                        &:hover
                            background-color var(--themeHover)
                        &:active
                            background-color var(--themeHover)
                .content-input
                    display none
                .content-tips
                    padding-top 16px
                    margin-bottom 8px
                    font-size 14px
                    color rgba(34, 34, 34, 0.4)
        .dark-theme__importmodal
            background #2A2C2E
            .importModal-header
                color #E6E6E6
                .header-close
                    svg
                        stroke #DADADF
            .importModal-content
                .content-loading
                    border 1.5px dashed #c6c6c6
                .content-box
                    border 1.5px dashed #48484A
                    background-color rgba(255, 255, 255, 0.04)
                    &:not(.no-drag):hover,&:not(.no-drag).active{
                      border-color #017FFF
                      background-color rgba(1, 127, 255, 0.06)
                      color #017FFF
                    }
                .content-text
                    color #FFFFFF66
                .content-btnbox
                    .content-btn
                        background-color #017fff;
                        &:hover
                            background-color #006adf
                        &:active
                            background-color #006adf
                .content-input
                    display none
                .content-tips
                    color #FFFFFF66
</style>
<template>
    <div class="importModal-mask" :class="{ noMask: isPC }" v-show="showImportGuide" @drop.prevent="" @dragover.prevent="">
        <div class="importModal-box" :class="{ 'dark-theme__importmodal': isPCDarkMode == 2 }">
            <div class="importModal-header">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_11412_26856)">
                        <rect width="16" height="16" fill="url(#paint0_linear_11412_26856)" />
                        <path
                            d="M7.99999 8.8125H4.75C4.30127 8.8125 3.9375 8.44873 3.9375 8C3.9375 7.55127 4.30127 7.1875 4.75 7.1875H7.99999C8.44872 7.1875 8.81249 7.55127 8.81249 8C8.81249 8.44873 8.44872 8.8125 7.99999 8.8125Z"
                            fill="white"
                            fill-opacity="0.6"
                        />
                        <path
                            d="M7.99999 4.75H4.75C4.30127 4.75 3.9375 4.38623 3.9375 3.9375C3.9375 3.48877 4.30127 3.125 4.75 3.125H7.99999C10.6924 3.125 12.875 5.30761 12.875 7.99999C12.875 10.6924 10.6924 12.875 7.99999 12.875H4.75C4.30127 12.875 3.9375 12.5112 3.9375 12.0625C3.9375 11.6137 4.30127 11.25 4.75 11.25H7.99999C9.79491 11.25 11.25 9.79491 11.25 7.99999C11.25 6.20507 9.79491 4.75 7.99999 4.75Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <linearGradient
                            id="paint0_linear_11412_26856"
                            x1="16.7272"
                            y1="18.6666"
                            x2="1.16582"
                            y2="-3.96816"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#0066FF" />
                            <stop offset="1" stop-color="#66CCFF" />
                        </linearGradient>
                        <clipPath id="clip0_11412_26856">
                            <rect width="16" height="16" rx="3.65049" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <span>{{ $t("title") }}</span>
                <div class="header-close" @click="close()">
                    <iconSymbol name="importClose" />
                </div>
            </div>
            <div class="importModal-content">
                <div class="content-loading" v-if="isLoading">
                    <img :src="require('@/home/assets/img/logoanimation.gif')" alt="" />
                </div>
                <label
                    for="content-input"
                    v-show="!isLoading"
                    ref="dropBox"
                    class="content-box"
                    :class="{ active: isInDragbox, 'no-drag': !pcSupportDrag }"
                    @dragenter="dragenter"
                    @dragleave="dragleave"
                    @dragover="dragover($event)"
                    @drop="drop($event)"
                >
                    <div class="vip-tag" :class="vip || visioLimit >= freeConvert ? 'vip' : 'limit-free'">
                        {{ vip || visioLimit >= freeConvert ? $t("vipTag") : $t("limitFree", { time: freeConvert - visioLimit }) }}
                    </div>
                    <div class="content-img">
                        <iconSymbol name="cloud-importIcon" />
                    </div>
                    <div class="content-text">{{ $t("tips1") }}</div>
                    <div class="content-btnbox">
                        <div class="content-btn">{{ $t("btn") }}</div>
                    </div>
                </label>
                <input
                    id="content-input"
                    class="content-input"
                    type="file"
                    :accept="isPrivate ? '.eddx' : '.eddx,.vsdx,.vsd'"
                    @change="fileInputChange"
                />
                <div class="content-tips">
                    {{ isPrivate ? $t("tips3") : $t("tips2") }}
                </div>
            </div>
        </div>
        <Modal v-model="uploadState" :title="$t('importSuccess')" @on-ok="asyncOK" @on-cancel="asyncCancel" :cancel-text="$t('cancelOpen')">
            <p>{{ $t("isOpen") }}</p>
        </Modal>
    </div>
</template>
<script lang="ts">
    declare var JSZip: any;
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class ImportModal extends Vue {
        isLoading: boolean = false;
        isInDragbox: boolean = false;
        showImportGuide: boolean = true;
        lastEnterEle = null;
        uploadState = false;
        uploadFilePath = "";
        pollingCount: number = 0;
        importType = "";
        importFileType = "";
        fileName = "";
        tempFile = null;
        freeConvert = 5; // visio文件转换限免5次

        close() {
            this.pollingCount = 0;
            this.showImportModal = false;
        }
        cleanState() {
            this.close();
            this.$store.commit("setState", {
                type: "showLoading",
                data: false,
            });
        }
        dragenter(e) {
            this.lastEnterEle = e.target;
            if (!this.isInDragbox) this.isInDragbox = true;
        }
        dragleave(e) {
            let leaveEle = e.target;
            if (leaveEle == this.lastEnterEle) {
                this.isInDragbox = false;
                this.lastEnterEle = null;
            }
        }
        dragover(e) {
            e.preventDefault();
        }
        drop(e) {
            e.preventDefault();
            let file = e.dataTransfer.files[0];
            this.tempFile = file;
            this.chooseFile(file);
            this.importType = "drag";
        }
        fileInputChange(e) {
            let file = e.target.files[0];
            this.tempFile = file;
            this.chooseFile(file);
            e.target.value = "";
            this.importType = "click";
        }
        chooseFile(file) {
            if (!this.$validateLogin()) return;
            if (!file) return;
            if (/\+/.test(file.name)) {
                this.$edMessage.error(this.$t("limitAddSymbol"));
                return;
            }
            let limitFunc = (type = "") => {
                if (type == "showLimitModal") {
                    this.$bus.$on("limitModalContinue", () => {
                        console.log("on event");
                        this.$bus.$off("limitModalContinue");
                        this.chooseFile(this.tempFile);
                    });
                    this.$store.commit("setState", {
                        type: "showLimitFileModal",
                        data: true,
                    });
                } else if (type == "showLimitCloudSpaceVIP") {
                    if (this.fuser) {
                        this.$bus.$emit("showCloudSpaceVipTips");
                    } else {
                        this.$checkAuth({
                            type: "cloudSpaceVIP",
                            buyTrigger: "cloudSpacePop",
                            pcParams: { newUpgrade: 6, upgrade: 0 },
                        });
                    }
                } else if (type == "showLimitCloudSpace") {
                    this.$checkAuth({
                        type: "cloudSpace",
                        buyTrigger: "cloudSpacePop",
                        pcParams: { newUpgrade: 6, upgrade: 0 },
                    });
                }
            };
            this.$openFile({
                params: "",
                fileType: "checkLimit",
                suffix: "",
                checkLimit: true,
                limitRange: this.$store.state.publicStore.runPlatform,
                limitCallback: limitFunc,
                vip: this.vip,
                isFullCouldSpace: this.isFullCouldSpace,
            }).then(() => {
                let fileName = file.name;
                let fileNameArr = fileName.split(".");
                let fileType = fileNameArr.pop();
                fileName = fileNameArr.join(".");
                this.fileName = fileName;
                if (!/^(eddx|vsdx|vsd)$/.test(fileType)) {
                    this.$edMessage.error(this.$t("fileFormatWrong"));
                    return;
                }
                if (fileType == "eddx") {
                    this.sensors.track("importFile", {
                        Catalogues: "openFileProcess",
                        import_file_type: "eddx",
                        import_way: this.importType,
                    });
                    this.importFileType = "eddx";
                    this.getFile(file);
                } else if (/^(vsdx|vsd)$/.test(fileType)) {
                    if (file.size > 1024 * 1024 * 20) {
                        this.$edMessage.error(this.$t("fileOverLimit"));
                        return;
                    }
                    this.$pcTrack(
                        JSON.stringify({
                            type: "openFileProcess",
                            action: "importFile",
                            event: "experience",
                            label: JSON.stringify({
                                import_file_type: "singleVisioFile",
                                import_way: "cloud",
                            }),
                        })
                    );
                    this.sensors.track("importFile", {
                        Catalogues: "openFileProcess",
                        import_file_type: "singleVisioFile",
                        import_way: this.importType,
                    });
                    this.importFileType = "singleVisioFile";
                    this.convertFile(file, fileName, `${fileType}`);
                }
                this.isLoading = true;
            });
        }
        convertFile(file, fileName, suffix) {
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
            };
            let pollingConvert = (u) => {
                this.$edApi.getConvertResult(Object.assign(u, params)).then((res) => {
                    console.log(res);
                    if (res.data && res.data.url) {
                        this.$edApi.downloadConvertFile({ url: res.data.url }).then((e) => {
                            console.log(123, e);
                            let convertedFile = new File([e.data], fileName + ".eddx");
                            this.pollingCount = 0;
                            this.getFile(convertedFile);
                        });
                    } else if (res.status == "error") {
                        if (res.msg == "Your subscription is expired") {
                            this.$edMessage.error(this.$t("serveError"));
                        } else if (res.msg == "empty file") {
                            this.$edMessage.error(this.$t("emptyFile"));
                        } else if (res.msg == "data invalid") {
                            this.$edMessage.error(this.$t("invalidName"));
                        } else {
                            this.$edMessage.error(this.$t("changeFail"));
                        }
                        this.close();
                        return;
                    } else {
                        if (this.pollingCount > 240) {
                            this.$edMessage.error(this.$t("limitTime"));
                            this.close();
                            return;
                        }
                        this.pollingCount++;
                        setTimeout(() => {
                            pollingConvert(u);
                        }, 500);
                    }
                });
            };
            let obj = Object.assign({ file, suffix }, params);
            this.$edApi.fileConversion(obj).then((res) => {
                let feLimit = !this.vip && this.visioLimit >= this.freeConvert; // 前端限制条件
                // 后端接口 + 前端限制
                if (res.status == "error") {
                    if (res.msg == "Your subscription is expired" || feLimit) {
                        this.$openBuyPage("importVisio");
                    } else if (res.msg == "empty file") {
                        this.$edMessage.error(this.$t("emptyFile"));
                    } else if (res.msg == "data invalid") {
                        this.$edMessage.error(this.$t("invalidName"));
                    } else {
                        this.$edMessage.error(this.$t("changeFail"));
                    }
                    this.close();
                } else {
                    pollingConvert(res.data);
                }
            });
        }
        get currentPath() {
            return this.$store.state.currentPath;
        }
        get currentPathId() {
            return this.$store.state.currentPathId;
        }
        getFile(file) {
            if (this.userInfo) {
                let encrypt = 0;
                let fzip = new JSZip();
                fzip.loadAsync(file).then(() => {
                    if (Object.keys(fzip.files).indexOf("encryptInfo") >= 0) {
                        // 加密文件
                        encrypt = 1;
                    }
                    this.$store.commit("setState", { data: true, type: "showLoading" });
                    let name = file.name.match(/(.*)\.eddx/i) && file.name.match(/(.*)\.eddx/i)[1];
                    let list = [];
                    this.$store.dispatch("getFloder", { prefix: this.currentPath }).then((res) => {
                        let folderList = res.data.data.folders || [];
                        let filesList = res.data.data.files || [];
                        let file_key = null;
                        if (this.isPrivate) {
                            filesList.map((item) => {
                                item.name = item.info.name;
                                return item;
                            });
                        } else {
                            filesList.map((item) => {
                                let list = item.key.split("/");
                                let n = list[list.length - 1];
                                n = n.match(/(.*)\.eddx/) && n.match(/(.*)\.eddx/)[1];
                                item.name = n;
                            });
                            filesList = filesList.filter((item) => {
                                if (item.key.match(/.+eddx$/)) {
                                    return true;
                                }
                                return false;
                            });
                        }
                        filesList.forEach((fileItem) => {
                            // let reg = new RegExp(`^${exp}(\\d*)$`)
                            let data = fileItem.name && fileItem.name.startsWith(name);
                            if (data) {
                                let res = fileItem.name.slice(name.length);
                                res = Number(res);
                                if (Number.isInteger(res)) {
                                    list.push(res);
                                }
                                file_key = fileItem.info.file_key;
                            }
                        });
                        list = list.sort((a, b) => a - b);
                        this.showImportGuide = false;
                        if (list.includes(0)) {
                            (<any>this).$Modal.confirm({
                                title: this.$t("cover"),
                                content: this.$t("isCover"),
                                okText: this.$t("confirm"),
                                cancelText: this.$t("cancel"),
                                onOk: () => {
                                    this.$store
                                        .dispatch("uploadFile", {
                                            file,
                                            name: this.currentPath + name + ".eddx",
                                            encrypt,
                                            fileName: name,
                                            folderId: this.currentPathId,
                                            action: "cover",
                                            file_key,
                                            cover: true,
                                        })
                                        .then((res) => {
                                            this.uploadFilePath = res.path;
                                            this.uploadState = true;
                                            this.$bus.$emit("refreshList");
                                            this.sensors.track("generateCloudFile", {
                                                Catalogues: "openFileProcess",
                                                file_source: "importFile",
                                            });
                                            this.$bus.$emit("getStorage");
                                            this.$store.commit("setState", {
                                                type: "showLoading",
                                                data: false,
                                            });
                                        })
                                        .catch((err) => {
                                            console.log(err);
                                            if (err == "storage space not enough") {
                                                this.$edMessage.error(this.$t("space"));
                                                this.$checkAuth({
                                                    type: "cloudSpace",
                                                    buyTrigger: "cloudSpacePop",
                                                    pcParams: { newUpgrade: 6, upgrade: 0 },
                                                });
                                            } else if (err == "read only") {
                                                this.$edMessage.error(this.$tc("readOnlyFile"));
                                            } else if (err !== "overLimit") {
                                                this.$edMessage.error(this.$t("uploadFail"));
                                            }
                                            this.cleanState();
                                        });
                                },
                                onCancel: () => {
                                    this.$store
                                        .dispatch("uploadFile", {
                                            file,
                                            name: this.currentPath + name + ".eddx",
                                            encrypt,
                                            fileName: name,
                                            folderId: this.currentPathId,
                                            cover: false,
                                        })
                                        .then((res) => {
                                            this.uploadFilePath = res.path;
                                            this.uploadState = true;
                                            this.$bus.$emit("getStorage");
                                            this.$bus.$emit("refreshList");
                                            this.$store.commit("setState", {
                                                type: "showLoading",
                                                data: false,
                                            });
                                        })
                                        .catch((err) => {
                                            console.log(err);
                                            if (err == "storage space not enough") {
                                                this.$edMessage.error(this.$t("space"));
                                            } else if (err !== "overLimit") {
                                                this.$edMessage.error(this.$t("uploadFail"));
                                            }
                                            this.cleanState();
                                        });
                                },
                            });
                        } else {
                            this.$store
                                .dispatch("uploadFile", {
                                    file,
                                    name: this.currentPath + name + ".eddx",
                                    encrypt,
                                    fileName: name,
                                    folderId: this.currentPathId,
                                })
                                .then((res) => {
                                    this.uploadFilePath = res.path;
                                    this.uploadState = true;
                                    this.$bus.$emit("refreshList");
                                    this.$bus.$emit("getStorage");
                                    this.$store.commit("setState", {
                                        type: "showLoading",
                                        data: false,
                                    });
                                })
                                .catch((err) => {
                                    console.log(err);
                                    if (err == "storage space not enough") {
                                        this.$edMessage.error(this.$t("space"));
                                    } else if (err == "overLimit") {
                                        this.$edMessage.error(this.$t("importOverLimit"));
                                    } else if (err !== "overLimit") {
                                        this.$edMessage.error(this.$t("uploadFail"));
                                    }
                                    this.cleanState();
                                });
                        }
                        console.log(name);
                        let ele = document.getElementById("inputFile");
                        if (ele) {
                            ele["value"] = "";
                        }
                    });
                });
            } else {
                let ts: any = this;
                ts.$bus.$emit("login");
            }
        }
        asyncOK() {
            if (this.isPC) {
                // pc 导入文件后打开文件
                let key = this.uploadFilePath;
                let filePath = key.match(/[^\/]+\/[^\/]+\/(.+)/) && key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                let params = Object.assign({ obj: filePath }, this.$store.getters.apiParam);
                if (this.importFileType == "singleVisioFile") {
                    this.$pcTrack(
                        JSON.stringify({
                            type: "openFileProcess",
                            action: "importToCanvasSuccess",
                            event: "experience",
                            label: JSON.stringify({
                                import_file_type: "singleVisioFile",
                                import_way: "cloud",
                            }),
                        })
                    );
                }
                this.$edApi.getDownFileAddress(params).then((signInfo) => {
                    let obj = key;
                    //中文站用的oss，英文站用的aws，通过getSignature得到的数据不一样
                    let paramForPc;
                    if (this.internal) {
                        let { sign, exp } = signInfo.data;
                        sign = encodeURIComponent(sign);
                        paramForPc = {
                            fileName: this.fileName,
                            sign,
                            exp,
                            obj,
                            type: "open",
                            from: "cloud",
                            accessid: this.OSSAccessKeyId,
                        };
                    } else {
                        let { path, query } = signInfo.data;
                        paramForPc = {
                            fileName: this.fileName,
                            path,
                            query,
                            type: "open",
                            from: "cloud",
                            accessid: this.OSSAccessKeyId,
                        };
                    }
                    this.setPCOpenRecord(obj);
                    (<any>window).$qt.jsCallCloudFileOperate(JSON.stringify(paramForPc));
                });
                this.close();
                return;
            }
            let ts: any = this;
            let maxAction = this.$store.state.appState;
            if (maxAction) {
                if (maxAction == "create") this.$edMessage.success(this.$t("create"));
                return;
            }
            this.$gaTrack("openFileProcess_enterCanvas", `fileSource: importfile}`);
            if (this.openInTabs) {
                location.href =
                    window.location.origin + (<any>this.$router).options.base + "app.html?" + ts.$zipFileName("obj=" + this.uploadFilePath);
                return;
            }
            let fileObj = this.isAd ? "obj=" + this.uploadFilePath + `&from=ad` : "obj=" + this.uploadFilePath;
            fileObj += "&file_source=importFile";
            let newTab: any = window.openPlus(
                window.location.origin + (<any>this.$router).options.base + "app.html?" + ts.$zipFileName(fileObj),
                this.uploadFilePath
            );
            // this.$store.state.winobj[this.uploadFilePath] = newTab;
            let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
            if (!openTabs.includes(this.uploadFilePath)) {
                openTabs.push(this.uploadFilePath);
            }
            this.sensors.track("importToCanvasSuccess", {
                Catalogues: "openFileProcess",
                import_file_type: this.importFileType,
                import_way: this.importType,
            });
            localStorage.setItem("openTabs", JSON.stringify(openTabs));
            this.close();
        }
        asyncCancel() {
            this.close();
        }
        setPCOpenRecord(name) {
            let params = Object.assign({ obj: name, size: 0, platform: this.$store.state.publicStore.runPlatform }, this.$store.getters.apiParam);
            this.$edApi
                .getCloudFileSign(params)
                .then((res) => {
                    if (res.msg === "file num over limit") {
                    } else if (res.msg === "storage space not enough") {
                    } else {
                        let params = Object.assign({ objId: res.data.id }, this.$store.getters.apiParam);
                        this.$edApi.addOpenRecord(params).then((e) => {
                            window.opener?.postMessage(
                                {
                                    type: "updateMyfile",
                                    updateRecentFile: true,
                                },
                                location.origin
                            );
                        });
                    }
                })
                .catch((err) => {});
        }
        get isAd() {
            return this.$store.state.isAd;
        }
        get showImportModal() {
            return this.$store.state.showImportModal;
        }
        set showImportModal(v) {
            this.$store.commit("setState", {
                type: "showImportModal",
                data: v,
            });
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get visioLimit() {
            return this.$store.state.visioLimit;
        }
        escClose(e) {
            if (e.keyCode == 27) {
                this.showImportModal = false;
            }
        }
        // 获取免费转换次数
        getConvertTime() {
            let param = {
                id: this.userInfo?.user_id,
                token: this.userInfo?.token,
                platform: this.$store.state.publicStore.runPlatform,
            };
            this.$edApi.getUserLimit(param).then((res) => {
                let convert_num = res.data.convert_num;
                this.$store.commit("setState", {
                    type: "visioLimit",
                    data: convert_num,
                });
            });
        }
        pcSupportDrag = true;
        checkPcDrag() {
            if (!this.isPC) return;
            let urlParmas = new URLSearchParams(location.search.substring(1));
            let nodrag = urlParmas.get("nodrag");
            if (nodrag && nodrag == "1") {
                this.pcSupportDrag = false;
            }
        }
        created() {
            this.checkPcDrag();
            if (!this.vip) this.getConvertTime();
            document.addEventListener("keydown", this.escClose);
        }
        beforeDestroy() {
            document.removeEventListener("keydown", this.escClose);
            let win: any = window;
            win.$qt && win.$qt.jsCallSetDragFlag && win.$qt.jsCallSetDragFlag(false);
        }
    }
</script>
<i18n>
{
  "zh": {
    "vipTag": "VIP专享",
    "limitFree": "可免费使用{time}次导入Visio功能",
    "title": "文件导入",
    "btn": "添加文件",
    "tips1": "直接拖入文件，即可上传",
    "tips2": "目前支持导入的文件类型：eddx、vsdx、vsd",
    "tips3": "目前支持导入的文件类型：eddx",
    "fileFormatWrong": "文件格式错误",
    "importSuccess": "导入成功",
    "isOpen": "是否立即打开？",
    "uploadFail": "上传失败，请重试",
    "space": "云空间已达上限， 删除文件或清理回收站",
    "cover": "提示",
    "isCover": "目标文件夹已存在同名文件，是否要覆盖？",
    "confirm": "覆盖",
    "cancel": "不覆盖",
    "importOverLimit": "云文件超过限制，导入失败",
    "notSupportFile": "导入失败,不支持此文件类型",
    "limitTime": "请求超时，请重试",
    "serveError": "网络异常，请稍后重试",
    "emptyFile": "文件内容为空",
    "changeFail": "解析失败，请重试",
    "invalidName": "名字不能包含特殊字符",
    "fileOverLimit": "文件不能大于20M",
    "cancelOpen": "取消",
    "limitAddSymbol": "文件名不能包含+",
    "readOnlyFile": "目标文件为仅查看文件，不可覆盖"
  },
  "en": {
    "vipTag": "Premium",
    "limitFree": "import a Visio file for free {time} times",
    "title": "Import",
    "btn": "Upload File",
    "tips1": "drag your files here ",
    "tips2": "supported file format:  eddx、vsdx、vsd  ",
    "tips3": "supported file format: eddx  ",
    "fileFormatWrong": "File format error",
    "importSuccess": "Import succeeded",
    "isOpen": "Do you want to open it immediately?",
    "uploadFail": "upload failed，please retry",
    "space": "Cloud space has reached the upper limit, delete files or clean up the recycle bin",
    "cover": "prompt",
    "isCover": "A file with the same name already exists in the target folder. Do you want to overwrite it?",
    "confirm": "Cover",
    "cancel": "Do not cover",
    "importOverLimit": "Import failed, your document amount reaches the limit",
    "notSupportFile": "Import failed, this file type is not supported",
    "limitTime": "Time out, please retry",
    "serveError": "Network exception, please try again later",
    "emptyFile": "file content is empty.",
    "changeFail": "Parsing failed, please try again.",
    "invalidName": "Invalid Name",
    "fileOverLimit": "The size of each file should be less than 20M",
    "cancelOpen": "cancel",
    "limitAddSymbol": "Filenames do not support +",
    "readOnlyFile": "The file is in read-only mode and cannot be overwritten."
  },
  "es": {
    "vipTag": "Premium",
    "limitFree": "Límite: {time} usos",
    "title": "Importar archivos",
    "btn": "Agregar archivos",
    "tips1": "Arrastra el archivo directamente para subirlo",
    "tips2": "Tipos de archivos actualmente admitidos para la importación: eddx, vsdx, vsd",
    "fileFormatWrong": "Error de formato de archivo",
    "importSuccess": "Importado exitosamente",
    "isOpen": "¿Quieres abrirlo ahora?",
    "uploadFail": "Error de carga, inténtalo de nuevo.",
    "space": "El espacio en la nube ha alcanzado el límite superior, elimine archivos o borre la papelera de reciclaje",
    "cover": "Noticia",
    "isCover": "Ya existe un archivo con el mismo nombre en la carpeta de destino. ¿Quieres sobrescribirlo?",
    "confirm": "cubrir",
    "cancel": "No cubrir",
    "importOverLimit": "El archivo en la nube supera el límite y la importación falla",
    "notSupportFile": "Error de importación, este tipo de archivo no es compatible",
    "limitTime": "Se agotó el tiempo de espera de la solicitud. Vuelve a intentarlo.",
    "serveError": "Excepción de red, inténtalo de nuevo más tarde",
    "emptyFile": "el contenido del archivo está vacío.",
    "changeFail": "El análisis falló, inténtalo de nuevo",
    "invalidName": "Nombre inválido",
    "fileOverLimit": "El archivo no puede tener más de 20 m",
    "readOnlyFile": "El archivo se encuentra en modo de solo lectura y no se puede sobrescribir."
  },
  "jp": {
    "vipTag": "プレミアム",
    "limitFree": "{time} 回まで",
    "title": "ファイルのインポート",
    "btn": "アップロード",
    "tips1": "ファイルをドラッグ＆ドロップしてアップロードできます",
    "tips2": "インポート可能なファイル形式：eddx、vsdx、vsd",
    "fileFormatWrong": "ファイル形式エラー",
    "importSuccess": "インポート成功",
    "isOpen": "今すぐ開きますか？",
    "uploadFail": "アップロードに失敗しました。再度お試しください。",
    "space": "クラウドスペースが上限に達しました。ファイルを削除するか、ごみ箱をクリアしてください。",
    "cover": "ご注意",
    "isCover": "対象フォルダに既に存在する同名のファイルがあります。上書きしますか？",
    "confirm": "上書きする",
    "cancel": "上書きしない",
    "importOverLimit": "クラウドファイルが制限を超えているので、インポートに失敗しました",
    "notSupportFile": "インポートに失敗しました。このファイル形式はサポートされていません",
    "limitTime": "リクエストがタイムアウトしました。再度お試しください",
    "serveError": "ネットワーク例外です。後でもう一度お試しください",
    "emptyFile": "ファイルの内容が空です",
    "changeFail": "解析に失敗しました。もう一度お試しください",
    "invalidName": "無効な名前",
    "fileOverLimit": "ファイルは20M以下にする必要があります",
    "readOnlyFile": "ファイルは読み取り専用モードのため、上書きできません。"
  },
  "fr": {
    "vipTag": "Premium",
    "limitFree": "Limite : {time} utilisation(s)",
    "title": "Importation de fichiers",
    "btn": "Ajouter des fichiers",
    "tips1": "Faites glisser le fichier directement pour télécharger",
    "tips2": "Types de fichiers actuellement pris en charge pour l'importation: eddx, vsdx, vsd",
    "fileFormatWrong": "Erreur de format de fichier",
    "importSuccess": "Importé avec succès",
    "isOpen": "Voulez-vous l'ouvrir maintenant?",
    "uploadFail": "Échec de l'importation, veuillez réessayer",
    "space": "L'espace cloud a atteint la limite supérieure, supprimez des fichiers ou videz la corbeille",
    "cover": "Rappeler",
    "isCover": "Un fichier portant le même nom existe déjà dans le dossier cible. Voulez-vous l'écraser?",
    "confirm": "OK",
    "cancel": "Annuler",
    "importOverLimit": "Le fichier cloud dépasse la limite et l'importation échoue",
    "notSupportFile": "L'importation a échoué, ce type de fichier n'est pas pris en charge",
    "limitTime": "La demande a expiré, veuillez réessayer",
    "serveError": "Exception réseau, veuillez réessayer plus tard",
    "emptyFile": "le contenu du fichier est vide",
    "changeFail": "Échec de l'analyse, veuillez réessayer",
    "invalidName": "Nom illégal",
    "fileOverLimit": "Le fichier ne peut pas dépasser 20m",
    "readOnlyFile": "Le fichier est en mode lecture seule et ne sera pas écrasé."
  },
  "pt": {
    "vipTag": "Premium",
    "limitFree": "Limite: {time} utilizações",
    "title": "Importar",
    "btn": "Upload arquivo",
    "tips1": "Arrastar seus arquivos aqui",
    "tips2": "Formato de arquivo compatível: eddx 、 vsdx 、 vsd",
    "fileFormatWrong": "Erro de formato de arquivo",
    "importSuccess": "Importação com sucesso",
    "isOpen": "Você quer abri-lo imediatamente?",
    "uploadFail": "Upload falhou, tente novamente",
    "space": "O espaço na nuvem atingiu o limite máximo, exclua arquivos ou limpe a lixeira",
    "cover": "Pronto",
    "isCover": "Já existe um arquivo com o mesmo nome na pasta de destino. Deseja substituí-lo?",
    "confirm": "Cobrir",
    "cancel": "Não se Cobrir",
    "importOverLimit": "A importação falhou, o valor do seu documento atingiu o limite",
    "notSupportFile": "A importação falhou, este tipo de arquivo não é compatível",
    "limitTime": "Tempo limite, por favor tente novamente",
    "serveError": "Exceção de rede, tente novamente mais tarde",
    "emptyFile": "o conteúdo do arquivo está vazio",
    "changeFail": "A análise falhou, tente novamente",
    "invalidName": "Nome Inválido",
    "fileOverLimit": "O tamanho de cada arquivo deve ser inferior a 20M",
    "readOnlyFile": "O arquivo está no modo somente leitura e não pode ser substituído."
  },
  "de": {
    "vipTag": "Premium",
    "limitFree": "Grenze: {time} Verwendung(en)",
    "title": "Importieren",
    "btn": "Datei hinzufügen",
    "tips1": "Ziehen Sie Ihre Dateien hierher",
    "tips2": "Derzeit für den Import unterstützte Dateitypen：eddx、vsdx、vsd",
    "fileFormatWrong": "Fehler beim Dateisformat",
    "importSuccess": "Importieren erfolgreich",
    "isOpen": "Möchten Sie das sofort öffnen？",
    "uploadFail": "Hochladen fehlgeschlagen, bitte versuchen Sie noch ",
    "space": "Der Cloud-Bereich hat die Obergrenze erreicht. Löschen Sie Dateien oder leeren Sie den Papierkorb",
    "cover": "Hinweis",
    "isCover": "Im Zielordner ist bereits eine gleichnamige Datei vorhanden. Möchten Sie diese überschreiben?",
    "confirm": "Bestätigen ",
    "cancel": "Abbrechen ",
    "importOverLimit": "Fehler beim Importieren, ",
    "notSupportFile": "Import fehlgeschlagen, dieser Dateityp wird nicht unterstützt",
    "limitTime": "Time out, bitte versuchen Sie mal erneut",
    "serveError": "Netzwerkausnahme, bitte versuchen Sie es später erneut",
    "emptyFile": "Dateiinhalt ist leer",
    "changeFail": "Parsing fehlgeschlagen, bitte versuchen Sie es erneut",
    "invalidName": "Ungültiger name",
    "fileOverLimit": "Größe der Datei darf nicht mehr als 20M sein",
    "readOnlyFile": "Die Datei ist schreibgeschützt und kann nicht überschrieben werden."
  },
  "it": {
    "vipTag": "Premium",
    "limitFree": "Limite: {time} utilizzi",
    "title": "Importa",
    "btn": "Aggiungere i file",
    "tips1": "Trascina il file direttamente per caricarlo",
    "tips2": "Formato di file supportato:：eddx、vsdx、vsd",
    "fileFormatWrong": "Errore di formato del file",
    "importSuccess": "Importazione riuscita",
    "isOpen": "Vuoi aprirlo adesso?",
    "uploadFail": "Errore di caricamento, riprova.",
    "space": "Lo spazio nel cloud ha raggiunto il limite superiore, elimina i file o svuota il cestino",
    "cover": "Nota",
    "isCover": "Esiste già un file con lo stesso nome nella cartella di destinazione. Vuoi sovrascriverlo?",
    "confirm": "Coprire",
    "cancel": "Non coprire",
    "importOverLimit": "Il file cloud supera il limite e l'importazione non riesce",
    "notSupportFile": "Errore di importazione, questo tipo di file non è supportato",
    "limitTime": "La richiesta è scaduta. Riprova.",
    "serveError": "Eccezione di rete, riprova più tardi",
    "emptyFile": "il contenuto del file è vuoto",
    "changeFail": "Analisi non riuscita, riprova",
    "invalidName": "Nome non Valido",
    "fileOverLimit": "Il file non può essere oltre di 20 m",
    "readOnlyFile": "Il file è in modalità di sola lettura e non può essere sovrascritto."
  },
  "tw": {
    "vipTag": "Premium",
    "limitFree": "限制：使用 {time} 次",
    "title": "檔案導入",
    "btn": "添加檔案",
    "tips1": "直接拖入檔案，即可上傳",
    "tips2": "目前支持導入的檔案類型：eddx、vsdx、vsd",
    "fileFormatWrong": "檔案格式錯誤",
    "importSuccess": "導入成功",
    "isOpen": "是否立即打開？",
    "uploadFail": "上传失败，请重试",
    "space": "雲端硬碟已達上限， 刪除檔案或清理回收站",
    "cover": "提示",
    "isCover": "目標資料夾已存在同名檔案，是否要覆蓋？",
    "confirm": "覆蓋",
    "cancel": "不覆蓋",
    "importOverLimit": "雲端硬碟檔案超過限制，導入失敗",
    "notSupportFile": "導入失敗,不支持此檔案類型",
    "limitTime": "請求超時，請重試",
    "serveError": "網絡異常，請稍後重試",
    "emptyFile": "文件內容為空",
    "changeFail": "解析失敗，請重試",
    "invalidName": "名字不能包特殊字符",
    "fileOverLimit": "檔案不能大於20m",
    "readOnlyFile": "檔案處於唯讀模式，無法覆寫。"
  },
  "kr": {
    "vipTag": "프리미엄",
    "limitFree": "사용 제한: {time}번",
    "title": "파일 가져오기",
    "btn": "파일 추가",
    "tips1": "파일을 드래그하면 바로 업로드됩니다.",
    "tips2": "지원하는 파일 형식：eddx、vsdx、vsd",
    "fileFormatWrong": "파일 형식 오류",
    "importSuccess": "가져오기 성공",
    "isOpen": "지금여시겠습니까?",
    "uploadFail": "업로드 실패,다시 시도하세요~",
    "space": "클라우드 공간이 상한에 도달했습니다. 파일을 삭제하거나 휴지통을 비우십시오.",
    "cover": "팁",
    "isCover": "동일한 이름의 파일이 대상 폴더에 이미 있습니다. 덮어 쓰시겠습니까?",
    "confirm": "덮어쓰기",
    "cancel": "덮어쓰지 않기",
    "importOverLimit": "클라우드 파일이 제한을 초과하여 가져 오기에 실패했습니다.",
    "notSupportFile": "가져 오기 실패했습니다.이 파일 형식은 지원되지 않습니다.",
    "limitTime": "요청 시간이 초과되었습니다. 다시 시도하세요~",
    "serveError": "네트워크 예외입니다. 나중에 다시 시도하십시오.",
    "emptyFile": "파일 내용이 비어 있습니다",
    "changeFail": "구문 분석에 실패했습니다. 다시 시도해 주세요.",
    "invalidName": "이름은 특수 문자를 포함 할 수 없습니다.",
    "fileOverLimit": "파일 크기는 20m을 초과할 수 없습니다.",
    "readOnlyFile": "파일이 읽기 전용 모드이므로 덮어쓸 수 없습니다."
  },
  "id": {
    "vipTag": "Premium",
    "limitFree": "import a Visio file for free {time} times",
    "title": "Impor",
    "btn": "Unggah File",
    "tips1": "seret file Anda ke sini ",
    "tips2": "format file yang didukung: eddx、vsdx、vsd  ",
    "tips3": "format file yang didukung: eddx  ",
    "fileFormatWrong": "Format file salah",
    "importSuccess": "Impor berhasil",
    "isOpen": "Anda ingin segera membukanya?",
    "uploadFail": "gagal mengunggah，coba lagi",
    "space": "Ruang cloud telah mencapai batas. Hapus file atau kosongkan tempat sampah",
    "cover": "perintah",
    "isCover": "File dengan nama yang sama sudah ada di folder target. Ingin menimpanya?",
    "confirm": "Timpa",
    "cancel": "Jangan timpa",
    "importOverLimit": "Impor gagal. Jumlah dokumen Anda telah mencapai batas",
    "notSupportFile": "Impor gagal. Jenis file ini tidak didukung",
    "limitTime": "Waktu habis. Coba lagi",
    "serveError": "Pengecualian jaringan, coba lagi nanti",
    "emptyFile": "konten file kosong",
    "changeFail": "Parsing gagal, harap coba lagi",
    "fileOverLimit": "Ukuran setiap file harus kurang dari 20 M",
    "invalidName": "Nama Tidak Valid",
    "cancelOpen": "batalkan"
  }
}
</i18n>
